import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { useMatchAtLeastOneRole } from 'utils/hooks';
import { RoleNames } from 'utils/constants';
import NetworkForm from './NetworkForm';
import NetworksTable from './NetworksTable';

const Networks = () => {
    const { path } = useRouteMatch();
    const userIsStandardServicer = useMatchAtLeastOneRole([RoleNames.SERVICER_STANDARD]);

    return (
        <Switch>
            {!userIsStandardServicer && <Route path={`${path}/create`} component={NetworkForm} />}
            {!userIsStandardServicer && <Route path={`${path}/edit/:id`} component={NetworkForm} />}
            <Route path={path} render={() => <NetworksTable />} />
        </Switch>
    );
};

export default Networks;
